var React = require('react');

function ArrowCircleSm (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 1.33615C6.17497 1.33615 1.45285 6.05827 1.45285 11.8833C1.45285 17.7083 6.17497 22.4304 12 22.4304C17.825 22.4304 22.5471 17.7083 22.5471 11.8833C22.5471 6.05827 17.825 1.33615 12 1.33615Z","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.28236 11.813L16.7178 11.7068","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M9.87988 14.5496L7.28238 11.813","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M10.019 9.21548L7.28238 11.813","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

ArrowCircleSm.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowCircleSm;

ArrowCircleSm.default = ArrowCircleSm;
